import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import UploadedImageRow from '../shared/UploadedImageRow';
import SettingsModal from './SettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  type: 'left' | 'right';
  settings?: boolean;
}

const NewUploadedImageRow: FC<Props> = ({
  image,
  imageIndex,
  setImages,
  type,
  settings,
}) => {
  const settingsApplied =
    getWatermarkTag(image) !== 'none' ||
    image.divider !== 'white' ||
    image.brakes ||
    !image.quotes ||
    image.textPosition !== 'bottom';

  return (
    <UploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings={settings}
      settingsApplied={settingsApplied}
      aspectRatio={675 / 1004}
      imgRatioX={51}
      imgRatioY={80}
      settingsModal={
        <SettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages}
          type={type}
          onClose={() => {}}
        />
      }
    />
  );
};

export default memo(NewUploadedImageRow);
